import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { SettingVariables, SettingArgs } from './queryVariables/setting';
/**
 * Resource ustawienia
 *
 * @export
 * @class SettingResource
 * @extends {EntityResource<Setting>}
 */
export class SettingResource extends EntityResource {
    constructor() {
        super({ entityName: 'setting' });
        this.getFields = {
            id: true,
            code: true,
            description: true,
            value: true,
            valueType: true,
            group: { id: true }
        };
        this.listFields = {
            id: true,
            code: true,
            description: true,
            group: { id: true }
        };
        this.listVariables = { filters: 'SettingFilters' };
        this.addVariables = SettingVariables;
        this.addArgs = SettingArgs;
        this.updateVariables = { id: 'Int!', ...SettingVariables };
        this.updateArgs = { id: new VariableType('id'), ...SettingArgs };
    }
    /**
     *
     * Dodanie ustawienia
     *
     * @param {*} setting
     * @returns {Promise<number>}
     * @memberof SettingResource
     */
    add(setting) {
        return super.add({ setting });
    }
    /**
     * Aktualizacja ustawienia
     *
     * @param {number} id
     * @param {*} model
     * @returns {Promise<number>}
     * @memberof SettingResource
     */
    update(id, model) {
        return super.update(id, { setting: { ...model, id: undefined } });
    }
    /**
     * Pobieram ustawienia po kodzie
     *
     * @param {string} code
     * @returns {Promise<Setting>}
     * @memberof SettingResource
     */
    settingFind(code) {
        const query = this.prepareOptions({
            query: {
                __variables: { code: 'String!' },
                settingFind: {
                    id: true,
                    value: true,
                    __args: {
                        code: new VariableType('code')
                    }
                }
            }
        });
        return this.query({
            query,
            variables: { code }
        }, 'settingFind');
    }
    /**
     * Pobieram publiczne ustawienia po kodzie
     *
     * @param {string} code
     * @returns {Promise<Setting>}
     * @memberof SettingResource
     */
    settingFindPublic(code) {
        const query = this.prepareOptions({
            query: {
                __variables: { code: 'String!' },
                settingFindPublic: {
                    id: true,
                    code: true,
                    valueType: true,
                    value: true,
                    __args: {
                        code: new VariableType('code')
                    }
                }
            }
        });
        return this.query({
            query,
            variables: { code }
        }, 'settingFindPublic');
    }
}
export const settingResource = new SettingResource();
//# sourceMappingURL=setting.resource.js.map